<script setup lang="ts">
const { isMobile } = useDevice()
const configStore = useConfigStore()

if (isMobile)
  configStore.appContentLayoutNav = 'vertical'

const systemSettings = useSystemSettingsStore()

systemSettings.fetchSystemSettings()
</script>

<template>
  <VApp>
    <NuxtLayout>
      <NuxtPage />
    </NuxtLayout>
  </VApp>
</template>
